export interface ETSConfig {
  writeKey: string;
  endpoint?: string;
  flushAt?: number;
  flushInterval?: number;
  maxRetries?: number;
  debug?: boolean;
  /**
   * Shadow mode (dry-run). Quando true, o SDK coleta e enfileira eventos
   * normalmente, mas o transport dropa silenciosamente. Setado por
   * `window.__ETS_CONFIG__.shadow` via interceptor (injection_config.mode
   * === "shadow"). Log em debug.
   */
  shadow?: boolean;
  /**
   * When true, the SDK transforms each batch into the legacy ets-wa shape
   * via `@ets/legacy-adapter` and posts with `X-ETS-Key` instead of
   * `Authorization: Basic`. Use when the SDK targets the legacy ets-wa
   * collector directly, without the interceptor Worker in the path.
   *
   * Default: false (standard ingest_http_v2 to interceptor / new collector).
   */
  legacyMode?: boolean;
}

export interface ETSResolvedConfig {
  writeKey: string;
  endpoint: string;
  flushAt: number;
  flushInterval: number;
  maxRetries: number;
  debug: boolean;
  shadow: boolean;
  legacyMode: boolean;
}

export const DEFAULT_CONFIG = {
  endpoint: "https://c.etus.io/v1/b",
  flushAt: 10,
  flushInterval: 5000,
  maxRetries: 3,
  debug: false,
  shadow: false,
  legacyMode: false,
} as const;

export function resolveConfig(config: ETSConfig): ETSResolvedConfig {
  if (!config.writeKey) {
    throw new Error("ETS: writeKey is required");
  }

  return {
    writeKey: config.writeKey,
    endpoint: config.endpoint ?? DEFAULT_CONFIG.endpoint,
    flushAt: config.flushAt ?? DEFAULT_CONFIG.flushAt,
    flushInterval: config.flushInterval ?? DEFAULT_CONFIG.flushInterval,
    maxRetries: config.maxRetries ?? DEFAULT_CONFIG.maxRetries,
    debug: config.debug ?? DEFAULT_CONFIG.debug,
    shadow: config.shadow ?? DEFAULT_CONFIG.shadow,
    legacyMode: config.legacyMode ?? DEFAULT_CONFIG.legacyMode,
  };
}
